import CroyptoJS from "crypto-js";

export function aesEncrypt(plainText) {
  let aseKey = "e75e2d3126357d031ddaf412f9110f66";
  let ivKey = "1234567812345678";
  // 将字符串转为WordArray
  const key = CroyptoJS.enc.Utf8.parse(aseKey);
  const iv = CroyptoJS.enc.Utf8.parse(ivKey);

  const encrypted = CroyptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    mode: CroyptoJS.mode.CBC,
    padding: CroyptoJS.pad.Pkcs7,
  });
  // 返回base64格式密文
  return encrypted.toString();
}
